module.exports = __webpack_public_path__ + "static/SimulationInvest-cab2a650e6db909f7a3057ed847c37d4.png";